import Icon from "@components/ui/Icon";
import { FACEBOOK_LINK, INSTAGRAM_LINK } from "@constants";
import { Trans, t } from "@helpers/translate";
import Link from "next/link";
import React from "react";

const SocialPlatformCard = () => {
  return (
    <div className="grid justify-center">
      <h3 className="text-3xl font-semibold mb-6 pb-2 inline-block">
        <Trans>Follow us on social media</Trans>
      </h3>

      <div className="flex justify-items-center place-items-center justify-center">
        <ul>
          <li>
            <Link
              href={INSTAGRAM_LINK}
              passHref
              target="_blank"
              title={t({
                id: "common.link.title",
                message: "GoWithGuide - Private Tours & Local Tour Guides",
              })}
              rel="noopener noreferrer"
            >
              <Icon icon="instagram" size="md" />
            </Link>
          </li>
        </ul>

        <ul className="mx-5">
          <li>
            <Link
              href={FACEBOOK_LINK}
              passHref
              target="_blank"
              title={t({
                id: "common.link.title",
                message: "GoWithGuide - Private Tours & Local Tour Guides",
              })}
              rel="noopener noreferrer"
            >
              <Icon icon="facebookRound" size="md" />
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default SocialPlatformCard;
